import { render } from "./BackendLogout.vue?vue&type=template&id=b39c6ad2"
import script from "./BackendLogout.vue?vue&type=script&lang=js"
export * from "./BackendLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__